
import {useState} from "react";
import {PhoneNumberInput} from "../../../components/Dialer/components/PhoneInput";
import {PhoneHQGlyph, PhoneHQTooltip} from 'ch3-ui-lib';

interface ForwardCallProps {
    isValid: Function;
    type: string;
    msisdn: number | null | undefined;
}

const ForwardCall = ({isValid ,msisdn, type}: ForwardCallProps) => {
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>(msisdn ? msisdn.toString() : undefined);
    const handleChange = (val: number) => {
        if (isValid(val, type)) {
            setPhoneNumber(val.toString());
        }
    }
    return (
        <div className='mb-8'>
            <div className='text-sm text-ink-muted mt-2 mb-5'>
                All incoming calls will be forwarded to this number.
            </div>
            <PhoneNumberInput phoneNumber={phoneNumber}
                              onPhoneNumberChange={(val) => handleChange(val)}
                              onPhoneNumberClear={() => setPhoneNumber(undefined)}/>
            <div className={'flex text-sm text-ink-muted mt-2 mb-5 gap-2'}>
                            Forwarding calls may incur extra charges.
                            <PhoneHQTooltip content={'Please note that forwarding calls will incur per-minute fees based on the pricing of outbound calls.'}><div className=" flex items-center">
                                        <PhoneHQGlyph name='question_mark' size={12} className='bg-black text-white w-4 h-4 justify-center'/>
                                    </div></PhoneHQTooltip>
                        </div>
        </div>

    )
}
export default ForwardCall;
